<template>
  <div class="info-check" :class="{'info-check-ac': ac}">
    <header-component
      :is-soon="false"
      :progression="false"
      img-left="/trocachip/img/arrow-left-light.svg"
      img-right="/trocachip/img/access-light.svg"
      class="header-component"
    />
    <!-- body -->
    <div class="info-check_body">
      <div class="mobile-container">
        <h2 class="info-check_title">Antes de seguir verifique essas informações</h2>
        <div class="info-check_checklist">
          <p class="info-check_checklist_title">Para realizar a troca do seu chip vamos precisar desses dados:</p>
          <div class="info-check_checklist__list">
            <p class="info-check_checklist__item">
              <i></i>
              <span>Número do protocolo de bloqueio da sua linha.</span>
            </p>
            <p class="info-check_checklist__item">
              <i></i>
              <span>Novo chip TIM com a embalagem em mãos.</span>
            </p>
          </div>
        </div>
      </div>
    </div>
    <div :class="{ 'background-desktop-black': ac, 'background-desktop': !ac }"></div>
    <!-- end body -->
    <!-- footer -->
    <div class="info-check_footer">
      <div class="mobile-container">
        <div class="info-check_footer_button">
          <action-button theme="light_full" @click="onClickAdvance">Continuar</action-button>
        </div>
        <div class="info-check_footer_button">
          <action-button theme="light_bordered" @click="onClickCallToSupport">Ligar para a TIM</action-button>
        </div>
      </div>
    </div>
    <!-- end footer -->
    <!-- call to support -->
    <alert
      description="Ligue para a Central de Atendimento TIM"
      :call-center="true"
      message="Para trocar seu chip, entre em contato através do 1056."
      v-on:close="onCloseCallToSupportAlert"
      v-if="activeCallToSupportAlert"
    />
    <!-- end call to support -->
  </div>
</template>

<script>
  import {mapState} from "vuex"
  import ActionButton from '@/components/ActionButton'
  import Alert from "../components/Alert"
  import HeaderComponent from '@/components/HeaderComponent'

  export default {
    name: 'InformationCheck',
    components: {
      ActionButton,
      Alert,
      HeaderComponent
    },
    data() {
      return {
        activeCallToSupportAlert: false
      };
    },
    computed: {
      ...mapState({
        ac: state => state.ac
      })
    },
    methods: {
      onClickAdvance() {
        this.$router.push({name: 'new-chip-information'})
      },
      onClickCallToSupport() {
        this.activeCallToSupportAlert = true;
      },
      onCloseCallToSupportAlert() {
        this.activeCallToSupportAlert = false;
      }
    }
  };
</script>

<style lang="scss" scoped>
  .info-check {
    display: flex;
    flex-direction: column;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    min-height: 100%;
    padding-top: 96px;
    box-sizing: border-box;
    background-color: #003091;
  }

  .info-check.info-check-ac {
    background-color: #1C1C1C;
  }

  .info-check_body {
    flex: 1;
  }

  .info-check_title {
    display: block;
    margin: 0;
    padding: 0;
    color: #FFFFFF;
    text-align: center;
    font-family: timsans_thin;
    font-size: 1.875rem;
    line-height: normal;
  }

  .info-check-ac .info-check_title {
    color: #FFFF00;
  }

  .info-check_checklist {}

  .info-check_checklist_title {
    display: block;
    margin: 26px 0 0 0;
    padding: 0;
    color: rgba(255, 255, 255, 0.6);
    text-align: center;
    font-family: timsans_regular;
    font-size: 0.9375rem;
    line-height: normal;
  }

  .info-check_checklist__list {
    margin-top: 18px;
  }

  .info-check_checklist__item {
    position: relative;
    display: block;
    margin: 0;
    padding: 10px 0 10px 20px;
    color: #FFFFFF;
    text-align: left;
    font-family: timsans_regular;
    font-size: 0.9375rem;
    line-height: normal;

    i {
      position: absolute;
      top: 14px;
      left: 0;
      display: inline-block;
      width: 12px;
      height: 12px;
      margin: 0;
      padding: 0;
      background-image: url("../assets/images/icon-check.png");
      background-repeat:  no-repeat;
      background-position: center center;
      background-size: 100%;
    }
  }

  .info-check_footer {
    padding-top: 40px;
    padding-bottom: 40px;
  }

  .info-check_footer_button {
    margin-top: 24px;

    &:first-child {
      margin-top: 0;
    }
  }


  @media (min-width: 768px) {
    .info-check {
      display: grid;
      grid-auto-columns: 50% 50%;
      grid-template-areas:
                    'header header'
                    'body background'
                    'footer background'
    ;
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      min-height: 100%;
      padding-top: 0;
      box-sizing: border-box;
      background-color: #003091;
    }

    .header-component {
      width: 45%;
      grid-area: header;
    }

    .info-check.info-check-ac {
      background-color: #1C1C1C;
    }

    .info-check_body {
      grid-area: body;
      margin-top: 139px;
    }

    .background-desktop {
      grid-area: background;
      width: 100%;
      height: 100vh;
      flex: 1;
      background: url("../assets/images/desktop@3x.png") no-repeat;
      background-size: cover;
    }

    .background-desktop-black {
      grid-area: background;
      width: 100%;
      height: 100vh;
      display: block;
      background: url("../assets/images/desktop-black.png") no-repeat;
      background-size: cover;
    }

    .info-check_title {
      width: 300px;
      display: block;
      margin: 0;
      padding: 0;
      color: #FFFFFF;
      text-align: center;
      font-family: timsans_thin;
      font-size: 2em;
      font-weight: 300;
      line-height: 1.2;
    }

    .info-check-ac .info-check_title {
      color: #FFFF00;
    }

    .info-check_checklist {}

    .info-check_checklist_title {
      width: 300px;
      display: block;
      margin: 26px 0 0 0;
      padding: 0;
      color: rgba(255, 255, 255, 0.6);
      text-align: center;
      font-family: timsans_regular;
      font-size: 1em;
      line-height: normal;
    }

    .info-check_checklist__list {
      margin-top: 18px;
    }

    .info-check_checklist__item {
      width: 300px;
      position: relative;
      display: block;
      margin: 0;
      padding: 10px 0 10px 20px;
      color: #FFFFFF;
      text-align: left;
      font-family: timsans_regular;
      font-size: 0.9375rem;
      line-height: normal;

      i {
        position: absolute;
        top: 14px;
        left: 0;
        display: inline-block;
        width: 12px;
        height: 12px;
        margin: 0;
        padding: 0;
        background-image: url("../assets/images/icon-check.png");
        background-repeat:  no-repeat;
        background-position: center center;
        background-size: 100%;
      }
    }

    .info-check_footer {
      grid-area: footer;
      padding-top: 40px;
      padding-bottom: 40px;
    }

    .info-check_footer_button {
      width: 300px;
      margin-top: 24px;

      &:first-child {
        margin-top: 0;
      }
    }
  }
  @media (min-width: 1024px) {

    .info-check_title {
      width: 368px;
    }

    .info-check_checklist_title {
      width: 368px;
    }

    .info-check_checklist__item {
      width: 368px;
    }

    .info-check_footer_button {
      width: 368px;
    }
  }
</style>
